// extracted by mini-css-extract-plugin
module.exports = {"Featured":"MarketReport_Featured_Featured__0LGtK","Image":"MarketReport_Featured_Image__cT6_c","Metadata":"MarketReport_Featured_Metadata__c0zRO"};